// Mirrors yallyhub-be/src/rental/contractual-rent/contractual-rent.service.ts

export type RentCategoryKey =
  | "rent"
  | "attributes"
  | "provisions"
  | "propertyTax"
  | "other";

export type CategoryAmounts = Record<RentCategoryKey, number>;

export interface ContractualRentSubLine {
  key: string;
  label: string;
  amount: number;
  lineCount: number;
}

export interface ContractualRentCategory {
  key: RentCategoryKey;
  label: string;
  amount: number;
  lineCount: number;
  contractCount: number;
  lines: ContractualRentSubLine[];
}

export interface ContractualRentCompany {
  companyId: number | null;
  companyName: string;
  contractCount: number;
  amounts: CategoryAmounts;
  total: number;
}

export interface ContractualRentMetrics {
  asOf: string;
  contractCount: number;
  contractCountByPhase: { active: number; termination: number; concept: number };
  conceptContractCount: number;
  conceptTotal: number;
  attributeOnlyContractCount: number;
  quarterlyContractCount: number;
  linesWithoutCurrentPrice: number;
  unclassifiedLineCount: number;
  totals: CategoryAmounts & { total: number };
  categories: ContractualRentCategory[];
  companies: ContractualRentCompany[];
}

/**
 * Categorical slots in fixed order — colour follows the category, never its
 * rank. Validated with the dataviz palette checker (light surface); the
 * contrast warning is covered by the labelled list beside the bar.
 */
export const CATEGORY_COLORS: Record<RentCategoryKey, string> = {
  rent: "#2a78d6",
  attributes: "#eb6834",
  provisions: "#1baf7a",
  propertyTax: "#eda100",
  other: "#e87ba4",
};

export const CATEGORY_DESCRIPTIONS: Record<RentCategoryKey, string> = {
  rent: "Basishuur van woningen, handelspanden en kortetermijnverhuur (grootboek 700001, 700002, 700004).",
  attributes:
    "Garages, staanplaatsen, bergingen, laadpalen … — elke lijn gekoppeld aan een gebouwattribuut of op grootboek 700003, ook losse attribuutcontracten.",
  provisions:
    "Voorschotten op kosten en doorrekening huurlasten (700020, 700101–700105), ook provisies op parkings.",
  propertyTax: "Doorrekening onroerende voorheffing en belastingen (700030, 700031).",
  other:
    "Energie, meubilair en diensten (700005, 700006, 700202) die niet aan een attribuut hangen, plus lijnen met een onbekend grootboek.",
};
